import React from 'react';

const Facebook2Icon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.324 12.781h2.633v10.832c0 .215.172.387.387.387h4.46a.385.385 0 00.387-.387V12.832h3.024a.388.388 0 00.387-.34l.457-3.988a.399.399 0 00-.094-.3.381.381 0 00-.29-.134h-3.484V5.574c0-.754.407-1.136 1.207-1.136h2.278a.39.39 0 00.387-.387V.39a.388.388 0 00-.387-.387h-3.14C14.511 0 14.464 0 14.39 0c-.543 0-2.438.105-3.934 1.484-1.656 1.524-1.426 3.348-1.371 3.664V8.07H6.324a.39.39 0 00-.386.387v3.938c0 .214.175.386.386.386zm0 0"
      ></path>
    </svg>
  );
};

export default Facebook2Icon;
